import { gql } from '@apollo/client';

export const GET_MAM_SELF_REQUESTABLE_MARKETS = {
  query: gql`
    query GetMamSelfRequestableMarkets($search: String) {
      mam {
        selfRequestableMarkets(search: $search)
      }
    }
  `,
  rootNode: 'mam',
  queryNode: 'selfRequestableMarkets',
  textField: 'display',
  keyField: 'id'
};


export const GET_MAM_SELF_REQUESTABLE_GROUPS_BY_COUNTRY = {
  query: gql`
    query GetMamSelfRequestableGroupsByCountry($country: String!, $search: String) {
      mam {
        selfRequestableGroupsByCountry(country: $country, search: $search)
      }
    }
  `,
  rootNode: 'mam',
  queryNode: 'selfRequestableGroupsByCountry',
  textField: 'display',
  keyField: 'id'
};


export const CREATE_ACCESS_REQUEST11111 = gql`
  mutation CreateAccessRequest($request: AccessRequestInput!) {
    mam {
      createAccessRequest(request: $request)
    }
  }
`;

export const CREATE_ACCESS_REQUEST = gql`
  mutation CreateAccessRequest($request: MamRequestInput!) {
    mam {
      createAccessRequest(request: $request)
    }
  }
`;